/**
 * Password field with a visibility toggle.
 */
import React, { useState } from "react";
import { InputAdornment, OutlinedInput, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PropTypes from "prop-types";

import { asFunc, asString } from "utils/safeData";

/**
 * Outlined password input with show/hide control.
 *
 * @param {{ inputClassName?: string, InputClassName?: string, label?: React.ReactNode, value?: string, onChange?: Function }} props
 */
const VPassword = (props) => {
  const { inputClassName, InputClassName, label, value: rawValue, onChange: rawOnChange, ...rest } = props;
  const value = asString(rawValue);
  const onChange = asFunc(rawOnChange);

  const [showPassword, setShowPassword] = useState(false);

  /**
   * Toggles whether the password is visible.
   *
   * @returns {void}
   */
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  /**
   * Prevents the visibility button from stealing input focus.
   *
   * @param {React.MouseEvent} event Mouse event.
   * @returns {void}
   */
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <OutlinedInput
        label={label}
        value={value}
        onChange={onChange}
        type={showPassword ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
              {showPassword ? <VisibilityOff className="text-black dark:text-gray-500" /> : <Visibility className="text-black dark:text-gray-500" />}
            </IconButton>
          </InputAdornment>
        }
        inputprops={{
          className: InputClassName,
        }}
        inputProps={{
          className: inputClassName,
        }}
        {...rest}
      />
    </>
  );
};

VPassword.defaultProps = {
  InputClassName: "",
  value: "",
  variant: "outlined",
};

VPassword.propTypes = {
  inputClassName: PropTypes.string,
  InputClassName: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default VPassword;
